module.exports = (Promise.resolve(__parcel__require__("./" + "module.e28feb7a.b0f48a1e.js"))).then(() => parcelRequire('lo8RU'));